import cx from 'classnames';

import { makeid } from '../../constants/index';
import Card from './card';

import styles from '../../styles/homePage/planCardPopup.scss';

interface Props {
  data: any;
  show: boolean;
  hidePopup: VoidFunction;
  investClick: VoidFunction;
}

const PlanCardPopup = ({ data, show, hidePopup, investClick }: Props) => {
  if (!show) {
    return null;
  }
  return (
    <div className={cx(styles.popup)}>
      <div className={styles.overlay} onClick={hidePopup} />
      <div className={cx(styles.content)}>
        <span className={styles.close} onClick={hidePopup}>
          close
        </span>
        <Card data={data} className={styles.card} investClick={investClick} />
        <div className={styles.details}>
          <h4
            className={cx(
              'text--lg font--bold font--dark-grey',
              styles['details-header']
            )}
          >
            {data.popupData.basic.title}
          </h4>
          <ul className={styles['details-figures']}>
            {data.popupData.basic.details.map(detail => (
              <li className={styles.detail} key={makeid()}>
                <label className={styles['detail-label']}>{detail.label}</label>
                <span className={styles['detail-value']}>{detail.value}</span>
              </li>
            ))}
          </ul>
          <hr className={styles.spacer} />
          <h4
            className={cx(
              'text--lg font--bold font--dark-grey',
              styles['details-header'],
              styles['no-padding']
            )}
          >
            {data.popupData.moreDetails.title}
          </h4>
          <ul className={styles['more-details']}>
            {data.popupData.moreDetails.details.map(detail => (
              <li className={styles['more-detail']} key={makeid()}>
                <label>{detail.header}</label>
                <p>{detail.content}</p>
              </li>
            ))}
          </ul>
          <hr className={styles.spacer} />
          <h4
            className={cx(
              'text--lg font--bold font--dark-grey',
              styles['details-header'],
              styles['no-gap-below'],
              styles['no-padding']
            )}
          >
            {data.popupData.fundDetails.title}
          </h4>
          <ul className={styles.funds}>
            {data.popupData.fundDetails.funds.map(fund => (
              <li className={styles.fund} key={makeid()}>
                <div className={styles['fund-image-wrapper']}>
                  <img
                    className={styles['fund-image']}
                    src={`https://assets1.cleartax-cdn.com/clearsave/images/${fund.image}`}
                    alt={fund.name}
                  />
                </div>
                <div className={styles['fund-details']}>
                  <label
                    className={cx(
                      'block text--md ml10 float--left',
                      styles['fund-name']
                    )}
                  >
                    {fund.name}
                  </label>
                  {fund.details.map(detail => (
                    <div className={styles['fund-detail-group']} key={makeid()}>
                      <div className={styles['fund-label']}>{detail.label}</div>
                      {detail.type && detail.type === 'rating' ? (
                        <p className={styles['fund-detail']}>
                          {detail.value}
                          <img
                            width="32"
                            src="https://assets1.cleartax-cdn.com/clearsave/images/star.svg"
                            alt="Reliance Liquid-Treasury Plan(G)"
                          />
                        </p>
                      ) : (
                        <p className={styles['fund-detail']}>{detail.value}</p>
                      )}
                    </div>
                  ))}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PlanCardPopup;



// WEBPACK FOOTER //
// ./components/homePage/planCardPopup.tsx